/**
 * FO-typed adapter over the shared compare row (features/tag-rule-compare).
 * The generic row is structural — FO's `kind` discriminant rides through its
 * spreads untouched — so this only pins the FlowTagCondition typing.
 * For Media Devoted | Created By Ciro Autiero
 */

import { type FC } from 'react';
import { type FlowTagCondition } from '@trafficpulse/shared';

import { CompareConditionRow } from '@/features/tag-rule-compare';

type MetricCondition = Extract<FlowTagCondition, { kind: 'metric' }>;

interface FlowCompareConditionRowProps {
  condition: MetricCondition;
  onChange: (c: FlowTagCondition) => void;
  onRemove: () => void;
  canRemove: boolean;
}

export const FlowCompareConditionRow: FC<FlowCompareConditionRowProps> = ({
  condition,
  onChange,
  onRemove,
  canRemove,
}) => (
  <CompareConditionRow
    condition={condition}
    onChange={onChange}
    onRemove={onRemove}
    canRemove={canRemove}
  />
);

export default FlowCompareConditionRow;
